import styled from 'styled-components';
export default styled.button `
	border-color: var(--theme-border-color, #c3c6c6) !important;
	color: var(--theme-article-text-color, #3a3a3a);

	background: none;
	cursor: pointer;
	border: 1px solid;
	border-radius: 3px;
	box-sizing: content-box;
	display: inline-flex;

	font-family: arial, helvetica, sans-serif;
	font-size: 12px;
	font-weight: 600;

	justify-content: center;
	letter-spacing: 0.15px;
	line-height: 16px;
	margin: 0;
	min-height: 18px;
	outline: none;
	padding: 7px 18px;

	text-decoration: none;
	text-transform: uppercase;
	transition-duration: 0.3s;
	transition-property: background-color, border-color, color;
`;
